import { render, staticRenderFns } from "./dialogHeader.vue?vue&type=template&id=11522cbc&scoped=true&"
import script from "./dialogHeader.vue?vue&type=script&lang=js&"
export * from "./dialogHeader.vue?vue&type=script&lang=js&"
import style0 from "./dialogHeader.vue?vue&type=style&index=0&id=11522cbc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11522cbc",
  null
  
)

export default component.exports